import authService from "@/services/authService";

function parseRolesFromToken(token) {
    try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        const authorities = JSON.parse(payload.authorities || '[]');
        return authorities.map(a => a.authority || a);
    } catch (e) {
        return [];
    }
}

const state = {
    token: localStorage.getItem("token") || null,
    username: localStorage.getItem("username") || null,
    roles: JSON.parse(localStorage.getItem("roles") || '[]'),
    authenticationError: null
};

const getters = {
    isAuthenticated: state => !!state.token,
    getToken: state => state.token,
    getAuthenticationError: state => state.authenticationError,
    getUsername: state => state.username,
    getRoles: state => state.roles,
    isAdmin: state => state.roles.includes('ROLE_ADMIN')
};

const actions = {
    async login({ commit }, user) {
        try {
            const response = await authService.login(user);
            const { data } = response;
            const roles = parseRolesFromToken(data.token);
            commit('SET_TOKEN', data.token);
            commit('SET_USERNAME', data.username);
            commit('SET_ROLES', roles);
            localStorage.setItem("token", data.token);
            localStorage.setItem("username", data.username);
            localStorage.setItem("roles", JSON.stringify(roles));
            return data;
        } catch (error) {
            commit('SET_AUTHENTICATION_ERROR', error.response.data.message);
            return error.response.data;
        }
    },
    logout({ commit }) {
        localStorage.removeItem("token");
        localStorage.removeItem("username");
        localStorage.removeItem("roles");
        commit('CLEAR_TOKEN');
        commit('CLEAR_USERNAME');
        commit('CLEAR_ROLES');
    }
};

const mutations = {
    SET_TOKEN(state, token) {
        state.token = token;
    },
    SET_AUTHENTICATION_ERROR(state, error) {
        state.authenticationError = error;
    },
    SET_USERNAME(state, username) {
        state.username = username;
    },
    SET_ROLES(state, roles) {
        state.roles = roles;
    },
    CLEAR_TOKEN(state) {
        state.token = null;
    },
    CLEAR_USERNAME(state) {
        state.username = null;
    },
    CLEAR_ROLES(state) {
        state.roles = [];
    },
    CLEAR_AUTHENTICATION_ERROR(state) {
        state.authenticationError = null;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
